import store from "./index";

export default {
  store,
  install(Vue) {
    Vue.prototype.$store = store;
  }
};



// WEBPACK FOOTER //
// ./src/store/storePlugin.js